import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  tokenSolver,
  getFromStorage,
  rewards,
  scrollToTop,
  privGtmKey,
  rewardsLabel,
  getImg,
  toggleScrollLock,
  getCardDetail,
} from "../utils";
import { chevron_left, empty_rewards } from "./../pngs";
import {
  CoalitionSpinner,
  EmptyBlock,
  CoalitionCardRewards,
  CoalitionButton,
  CoalitionModal,
  CoalitionCardRewardsDetail,
  isTokenValid,
} from "./../components";
import {
  sendTag,
  event_properties_104_01,
  event_properties_104_02,
} from "./../components/CoalitionGtm";

export const RewardsPage = () => {
  const gtm = localStorage.getItem(privGtmKey);
  useEffect(() => {
    if (gtm) sendTag(gtm, event_properties_104_01());
  }, [gtm]);

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [rewardsCards, updateRewardsCards] = useState([]);

  useEffect(() => {
    if (!isTokenValid()) return navigate("/unauth");
    const setRewardsCards = async () => {
      setLoading(true);
      const rawRewards = getFromStorage(rewards);
      await updateRewardsCards(rawRewards);
      setLoading(false);
      scrollToTop();
    };
    setRewardsCards();
  }, []);

  return loading ? (
    <CoalitionSpinner />
  ) : (
    <div className="specific-page">
      <PagePrebuilt
        rewards={rewardsCards}
        buttonClicked={() => navigate(`/?${tokenSolver()}`)}
      />
    </div>
  );
};

const PagePrebuilt = ({ rewards = [], buttonClicked }) => {
  const gtm = localStorage.getItem(privGtmKey);
  const handleClick = (id, label) => {
    toggleModal(id);
    if (gtm) {
      let payload = event_properties_104_02();
      payload.reward_id = id;
      payload.reward_progress = label;
      payload.click_id = null;
      sendTag(gtm, payload);
    }
  };

  const [modal, setModal] = useState();
  const [shown, setShown] = useState(false);
  const [activeCard, setActiveCard] = useState();

  const toggleModal = (modal = false) => {
    setShown(Boolean(modal));
    toggleScrollLock();
    setActiveCard(getCardDetail(rewards, modal));
  };

  return (
    <>
      {!rewards || rewards.length === 0 ? (
        <>
          <EmptyBlock
            title={"Obtén recompensas"}
            description={
              "Muy pronto podrás llevarte productos de regalo al sumar tus compras"
            }
            emptyState={empty_rewards}
          >
            <CoalitionButton
              label="Volver al Inicio"
              klass="coalition-button-go-dashboard"
              onClickEvent={buttonClicked}
            />
          </EmptyBlock>
        </>
      ) : (
        <>
          <div className="carousel-cards">
            <>
              <CoalitionButton
                label={"Recompensas"}
                klass="nav-button"
                onClickEvent={buttonClicked}
              >
                {getImg(chevron_left, "back-icon")}
              </CoalitionButton>
            </>
            <div className="title">{"Obtén recompensas"}</div>
            <div className="description">
              {
                "Llévate productos de regalo al sumar tus compras y llegar a la meta"
              }
            </div>
            {rewards.map((i, k) => (
              <CoalitionCardRewards
                key={k}
                id={i.id}
                product={i.image}
                title={i.title}
                used={i.balance}
                needed={i.required_balance}
                availableToRedeem={i.available_to_redeem}
                showModal={() => handleClick(i.id, rewardsLabel(i))}
              />
            ))}
          </div>
          {shown ? (
            <CoalitionModal
              modalRef={(n) => setModal(n)}
              closeModal={() => toggleModal()}
              onKeyDown={(e) => (e.keyCode === 27 ? toggleModal() : null)}
              onClickOutside={(e) =>
                modal && modal.contains(e.target) ? null : toggleModal()
              }
              title={"Todo sobre la recompensa"}
            >
              <CoalitionCardRewardsDetail card={activeCard} />
            </CoalitionModal>
          ) : null}
        </>
      )}
    </>
  );
};
